// Tab-only handoff across Auth0. Never put invitation secrets in appState,
// query strings, localStorage, telemetry or the persisted application selectors.
const STORAGE_KEY = "vd.pending-owner-invitation";
export const INVITATION_MAX_AGE = 15 * 60 * 1000;
const TOKEN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.[A-Za-z0-9_-]{43}$/;
let pending = null;

export function invitationIsCurrent(value) {
  return Boolean(value && TOKEN.test(value.token) && typeof value.at === "number" && Date.now() - value.at >= 0 && Date.now() - value.at < INVITATION_MAX_AGE && typeof value.key === "string");
}

export function captureInvitation() {
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  const candidate = fragment.get("invite");
  if (candidate !== null) {
    window.history.replaceState({}, "", `${window.location.pathname}${window.location.search}`);
    clearInvitation();
    if (fragment.getAll("invite").length === 1 && [...fragment.keys()].length === 1 && TOKEN.test(candidate)) {
      pending = { token: candidate, at: Date.now(), key: window.crypto.randomUUID() };
      try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending)); } catch { /* Reopen link after sign-in if tab storage is blocked. */ }
    }
  } else {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || "null");
      if (invitationIsCurrent(value)) pending = value;
      else clearInvitation();
    } catch { clearInvitation(); }
  }
  return pending;
}

export function clearInvitation() {
  pending = null;
  try { window.sessionStorage.removeItem(STORAGE_KEY); } catch { /* No persisted secret to clear. */ }
}
